module.exports = __webpack_public_path__ + "static/media/ninth_newpaper_plant6.d326c640.png";